<mat-toolbar color="primary">
    <mat-toolbar-row>
        <h1>{{ headerTitle }}</h1>
    </mat-toolbar-row>
</mat-toolbar>

